export type DialogType = 'DELETE' | 'EDIT' | 'DISABLE' | 'OTHER' | 'BULKDELETE' | 'LOGOUT'

export type DefaultFieldType = {
    dialog: {
        content: string;
        button: ButtonType[]
    }
    replaceValue?: never
    type: 'OTHER'
}
export type FieldType = {
    dialog?: never
    type: 'DELETE' | 'EDIT' | 'DISABLE' | 'BULKDELETE' | 'LOGOUT',
    replaceValue: string
}

export type ButtonType =
    { id: number; name: string, }

export const Constant =
{
    DELETE:
    {
        content: 'Are you sure you want to remove this item?',
        button: [{ id: 2, name: 'Yes' }, { id: 1, name: 'No' }]
    },
    EDIT: {
        content: 'Are you sure you want to leave this item?',
        button: [{ id: 1, name: 'Stay' }, { id: 2, name: 'Leave Page' }]
    },
    DISABLE:
    {
        content: 'Are you sure you want to disable this item?',
        button:
            [{ id: 2, name: 'Yes' }, { id: 1, name: 'No' }]
    },
    BULKDELETE:
    {
        content: 'Are you sure you want to bulk remove these item?',
        button: [{ id: 2, name: 'Yes' }, { id: 1, name: 'No' }]
    },
    LOGOUT:
    {
        content: 'Are you sure you want to logout from this device?',
        button: [{ id: 2, name: 'Yes' }, { id: 1, name: 'No' }]
    }
}


